import ImageAttachments from '../components/ImageAttachments.js'
import AudioAttachments from '../components/AudioAttachments.js'
import FileAttachments from '../components/FileAttachments.js'
import ButtonAttachments from '../components/ButtonAttachments.js'
import FormAttachments from './FormAttachments.js'
import FormSubmitAttachments from './FormSubmitAttachments.js'
import GenericTemplateAttachments from '../components/GenericTemplateAttachments.js'
//import FormSubmitAttachment from './formSubmitAttachment.js'
import VideoAttachments from '../components/VideoAttachments.js'
import TextMessage from './TextMessage.js'
import InfoMessage from './InfoMessage.js' // message by system like convo join, convo tag, ...

var sb = require('@sb/util')
import Time from '../components/Time.js'

import store from '@sb/store'

export default {
	props: ['event'],

	render () {
		var ev = this.event || {}
		switch (ev.type) {
		case 'conversation_joined':
			// return this.renderMessageChatJoin()
			break
		case 'message_sent':
			return this.renderMessageSent(ev)
		case 'conversation_state_updated':
		case 'conversation_rating_requested':
		case 'conversation_rated':
			return <InfoMessage ev={ev} />
		}
		return null
	},

	methods: {
		focus () {
			this.$refs.formAttachments.focus()
		},
		renderAgentAvatar (ev) {
			let bytype = sb.get(ev, 'by.type')
			let byid = sb.get(ev, 'by.display_id', sb.get(ev, 'by.id'))

			if (bytype === 'user') return null

			var senderName = getSenderName(ev)
			var uri = sb.get(store.account, 'logo_url') || require('../../assets/img/image_default.png')

			// should replace with subiz logo
			if (byid !== 'system' || bytype !== 'dummy') {
				uri =
					sb.get(store.agentM[byid], 'avatar_url') ||
					sb.get(store.account, 'logo_url') ||
					require('../../assets/img/default_avatar.png')
			}

			return (
				<div class="message-sender">
					<img class="message-sender-avatar" src={sb.replaceFileUrl(uri)} />
					<p class="message-sender-name">{senderName}</p>
				</div>
			)
		},

		renderMessageSent (ev) {
			if (ev._thanks) {
				return (
					<div class="info-message">
						<span>{sb.get(ev, 'data.message.text')}</span>
					</div>
				)
			}

			var $sender = null
			if (ev.mode === 'lead') {
				$sender = this.renderAgentAvatar(ev)
			}

			var $time = null
			if (ev.mode === 'lead') {
				$time = (
					<div class="convo-event-time">
						<Time time={ev.created} />
					</div>
				)
			}

			let bycls = sb.get(this.ev, 'by.type') === 'user' ? 'user-message' : 'agent-message'
			return (
				<div class={`convo-event ${bycls}`}>
					{$time}
					{$sender}
					<TextMessage ev={ev} />
					<ImageAttachments ev={ev} />
					<AudioAttachments ev={ev} />
					<VideoAttachments ev={ev} />
					<FileAttachments ev={ev} />
					<ButtonAttachments ev={ev} />
					<FormAttachments vOn:submit={this.onFormSubmit} ref="formAttachments" ev={ev} />
					<FormSubmitAttachments ev={ev} />
					<GenericTemplateAttachments ev={ev} />
				</div>
			)
		},

		renderUpdateConvo (ev) {
			var state = sb.get(ev, 'data.conversation.state')
			if (state === 'active') return null
			if (state === 'pending') return null
			return <div class="message-system">{this.$t('conversation_state_updated', { state })}</div>
		},

		onFormSubmit () {
			this.$emit('formSubmit')
		},
	},
}

function getSenderName (ev) {
	let bytype = sb.get(ev, 'by.type')
	let byid = sb.get(ev, 'by.display_id', sb.get(ev, 'by.id'))
	if (byid === 'system' || bytype === 'dummy') return 'system'
	if (bytype === 'user') return sb.getUserDisplayName(store.user)
	if (bytype === 'agent') return sb.getAgentDisplayName(store.account, store.agentM[byid])
	return ''
}
